import { useEffect, useRef } from 'react';

// Som de rugido de leoa (royalty-free)
const ROAR_URL =
  'https://assets.mixkit.co/active_storage/sfx/2295/2295-preview.mp3';

const SESSION_KEY = 'rugido_leoa_played';

export function useRoarSound(volume = 0.55) {
  const playedRef = useRef(false);

  useEffect(() => {
    // Só toca uma vez por sessão
    if (sessionStorage.getItem(SESSION_KEY)) {
      playedRef.current = true;
      return;
    }

    const audio = new Audio(ROAR_URL);
    audio.volume = volume;
    audio.preload = 'auto';

    const playAudio = () => {
      if (playedRef.current) return;

      audio
        .play()
        .then(() => {
          playedRef.current = true;
          sessionStorage.setItem(SESSION_KEY, 'true');
        })
        .catch(() => {
          // Autoplay bloqueado pelo browser — aguarda interação
        });
    };

    // Tenta autoplay imediatamente
    playAudio();

    // Fallback: toca no primeiro toque ou clique do usuário
    const handleInteraction = () => {
      if (!playedRef.current) {
        playAudio();
      }
    };

    document.addEventListener('click', handleInteraction, { once: true });
    document.addEventListener('touchstart', handleInteraction, { once: true });
    document.addEventListener('scroll', handleInteraction, { once: true });

    return () => {
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
      document.removeEventListener('scroll', handleInteraction);
    };
  }, [volume]);
}
